import { Radio, RadioGroup, TextField } from '@fs/zion-ui'
import React from 'react'

// DATA-12381: the fields Family Tree supplies when the historical flag is on. The create dialog, the
// edit dialog and the read-only view all show the same ones, so they are described once here.
const TEXT_FIELDS = [
  { name: 'birthPlace', labelKey: 'birthPlace', fallback: 'Birth Place' },
  { name: 'gender', labelKey: 'gender', fallback: 'Gender', isGender: true },
  { name: 'deathDate', labelKey: 'deathDate', fallback: 'Death Date' },
  { name: 'deathPlace', labelKey: 'deathPlace', fallback: 'Death Place' },
  { name: 'parent1GivenName', labelKey: 'tools.lists.labels.parent1GivenName', fallback: 'Parent #1 Given Name' },
  { name: 'parent1Surname', labelKey: 'tools.lists.labels.parent1Surname', fallback: 'Parent #1 Surname' },
  { name: 'parent2GivenName', labelKey: 'tools.lists.labels.parent2GivenName', fallback: 'Parent #2 Given Name' },
  { name: 'parent2Surname', labelKey: 'tools.lists.labels.parent2Surname', fallback: 'Parent #2 Surname' },
  { name: 'spouseGivenName', labelKey: 'tools.lists.labels.spouseGivenName', fallback: 'Spouse Given Name' },
  { name: 'spouseSurname', labelKey: 'tools.lists.labels.spouseSurname', fallback: 'Spouse Surname' },
]

function rowKey(keyPrefix, name) {
  return keyPrefix ? `${keyPrefix}${name.charAt(0).toUpperCase()}${name.slice(1)}` : name
}

function GenderRadios({ value, namePrefix, onChange, t }) {
  return (
    <RadioGroup orientation="horizontal">
      <Radio
        name={`${namePrefix}GenderMale`}
        checked={value === 'Male'}
        label={t('gender.male', 'Male')}
        value="Male"
        onChange={(e) => onChange(e.target.value)}
      />
      <Radio
        name={`${namePrefix}GenderFemale`}
        checked={value === 'Female'}
        label={t('gender.female', 'Female')}
        value="Female"
        onChange={(e) => onChange(e.target.value)}
      />
    </RadioGroup>
  )
}

export function buildTreeDerivedReadRows({ t, values }) {
  return TEXT_FIELDS.map(({ name, labelKey, fallback }) => ({
    key: name,
    label: <b>{t(labelKey, fallback)}</b>,
    detail: values[name],
  }))
}

// keyPrefix and radioNamePrefix keep each dialog's row keys and radio names as they were.
export function buildTreeDerivedEditRows({ t, values, onChange, keyPrefix, radioNamePrefix }) {
  return TEXT_FIELDS.map(({ name, labelKey, fallback, isGender }) => ({
    key: rowKey(keyPrefix, name),
    label: <b>{t(labelKey, fallback)}</b>,
    detail: isGender ? (
      <GenderRadios value={values[name]} namePrefix={radioNamePrefix} onChange={(v) => onChange(name, v)} t={t} />
    ) : (
      <TextField type="text" value={values[name]} onChange={(e) => onChange(name, e.target.value)} />
    ),
  }))
}
